import {computed, inject, Injectable, signal} from "@angular/core";
import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {filter, map, Observable, tap} from "rxjs";
import {AuthService} from "@shared/api/auth.service";

@Injectable({
    providedIn: "root"
})
export class AuthGuard {
    private auth = inject(AuthService);


    private isAuthenticated = computed(() => this.auth.isAuthenticated());

    loader = signal<boolean>(false);

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean> {
        this.loader.set(true);
        return this.auth.isDoneLoading$
            .pipe(filter(isDone => isDone))
            .pipe(tap(_ => this.isAuthenticated() || this.auth.login()))
            .pipe(map(_ => this.isAuthenticated()))
            .pipe(tap(() => this.loader.set(false)));
    }
}
